import {
  CircleCheck,
  Clock,
  CircleAlert,
  RefreshCw,
  Bell,
  Car,
  Home,
  User,
  Settings,
  MapPin,
  MapPinOff,
  Package,
  Ellipsis,
  EllipsisVertical,
  Play,
  Target,
  CircleHelp,
  ArrowRight,
  LayoutDashboard,
  ClipboardList,
  Megaphone,
  Smartphone,
  Link as LinkIcon,
  Map as MapIcon,
  ChartBar,
  Trophy,
  Flame,
  Pencil,
  Repeat,
  Check,
  Wrench,
  AlarmClock,
  Ban,
  LockOpen,
  Lock,
  ChevronDown,
  ChevronRight,
  Phone,
  Ruler,
  Calculator,
  Loader2,
  X,
  Compass,
  ArrowLeftRight,
  ArrowLeft,
  Bot,
  Hand,
  Star,
  Printer,
  Keyboard,
  Sparkles,
  TriangleAlert,
  Search,
  Trash2,
  ChevronUp,
  Camera,
  Circle,
  CircleDot,
  CreditCard,
  Users,
  Download,
  Upload,
  TrendingUp,
  Factory,
  Clipboard,
  ClipboardCheck,
  Folder,
  Banknote,
  Wallet,
  Landmark,
  Tag,
  Siren,
  Plane,
  Pause,
  Paperclip,
  FileText,
  Calendar,
  Sun,
  Moon,
  SatelliteDish,
  Satellite,
  Key,
  Building2,
  Gift,
  Info,
  Recycle,
  Handshake,
  BookOpen,
  MessageCircle,
  Route,
  Blinds,
  Briefcase,
  Square,
  Snowflake,
  Leaf,
  Languages,
  Flag,
  DoorOpen,
  Eye,
  EyeOff,
  Plus,
  Minus,
  ExternalLink,
  Copy,
  Save,
  Send,
  QrCode,
  Power,
  Zap,
  ChevronLeft,
  ArrowUpDown,
  TrendingDown,
  Truck,
  Timer,
  Archive,
  Delete,
  Scroll,
  Puzzle,
  FlagTriangleRight,
  PhoneOff,
  PartyPopper,
  LocateFixed,
  Mic,
  Pin,
  PinOff,
  ListFilter,
  type LucideIcon,
} from 'lucide-react';
import type { CSSProperties } from 'react';

/**
 * Единый набор иконок проекта (admin + field). Все значки в UI идут через
 * <Icon name="…" />, а не сырыми эмодзи — стиль (толщина штриха, размер,
 * выравнивание) остаётся единым во всех приложениях. Реестр пополняется здесь,
 * один раз — и доступен сразу везде, кто импортирует @jaluzi/ui.
 */
const REGISTRY = {
  'check-circle': CircleCheck,
  clock: Clock,
  'alert-circle': CircleAlert,
  refresh: RefreshCw,
  bell: Bell,
  car: Car,
  home: Home,
  user: User,
  settings: Settings,
  'map-pin': MapPin,
  'map-pin-off': MapPinOff,
  'locate-fixed': LocateFixed,
  mic: Mic,
  pin: Pin,
  'pin-off': PinOff,
  filter: ListFilter,
  package: Package,
  'more-horizontal': Ellipsis,
  'more-vertical': EllipsisVertical,
  play: Play,
  target: Target,
  'help-circle': CircleHelp,
  'arrow-right': ArrowRight,
  dashboard: LayoutDashboard,
  'clipboard-list': ClipboardList,
  megaphone: Megaphone,
  smartphone: Smartphone,
  link: LinkIcon,
  map: MapIcon,
  chart: ChartBar,
  trophy: Trophy,
  flame: Flame,
  pencil: Pencil,
  repeat: Repeat,
  check: Check,
  wrench: Wrench,
  alarm: AlarmClock,
  ban: Ban,
  unlock: LockOpen,
  lock: Lock,
  'chevron-down': ChevronDown,
  'chevron-right': ChevronRight,
  phone: Phone,
  ruler: Ruler,
  calculator: Calculator,
  loader: Loader2,
  x: X,
  compass: Compass,
  'arrow-left-right': ArrowLeftRight,
  'arrow-left': ArrowLeft,
  bot: Bot,
  hand: Hand,
  star: Star,
  printer: Printer,
  keyboard: Keyboard,
  sparkles: Sparkles,
  'triangle-alert': TriangleAlert,
  search: Search,
  trash: Trash2,
  'chevron-up': ChevronUp,
  camera: Camera,
  circle: Circle,
  'circle-dot': CircleDot,
  'credit-card': CreditCard,
  users: Users,
  download: Download,
  upload: Upload,
  'trending-up': TrendingUp,
  factory: Factory,
  clipboard: Clipboard,
  'clipboard-check': ClipboardCheck,
  folder: Folder,
  banknote: Banknote,
  wallet: Wallet,
  landmark: Landmark,
  tag: Tag,
  siren: Siren,
  plane: Plane,
  pause: Pause,
  paperclip: Paperclip,
  'file-text': FileText,
  calendar: Calendar,
  sun: Sun,
  moon: Moon,
  'satellite-dish': SatelliteDish,
  satellite: Satellite,
  key: Key,
  building: Building2,
  gift: Gift,
  info: Info,
  recycle: Recycle,
  handshake: Handshake,
  book: BookOpen,
  message: MessageCircle,
  route: Route,
  blinds: Blinds,
  briefcase: Briefcase,
  square: Square,
  snowflake: Snowflake,
  leaf: Leaf,
  languages: Languages,
  flag: Flag,
  door: DoorOpen,
  eye: Eye,
  'eye-off': EyeOff,
  plus: Plus,
  minus: Minus,
  'external-link': ExternalLink,
  copy: Copy,
  save: Save,
  send: Send,
  'qr-code': QrCode,
  power: Power,
  zap: Zap,
  'chevron-left': ChevronLeft,
  'arrows-up-down': ArrowUpDown,
  'trending-down': TrendingDown,
  truck: Truck,
  timer: Timer,
  archive: Archive,
  'delete-key': Delete,
  scroll: Scroll,
  puzzle: Puzzle,
  'flag-checkered': FlagTriangleRight,
  'phone-off': PhoneOff,
  'party-popper': PartyPopper,
} satisfies Record<string, LucideIcon>;

export type IconName = keyof typeof REGISTRY;

export interface IconProps {
  name: IconName;
  /** Размер в px. По умолчанию 16 — под текст 13–15px. */
  size?: number;
  /** Цвет штриха. По умолчанию наследуется от родителя (currentColor). */
  color?: string;
  /** Толщина штриха lucide. По умолчанию 2. */
  strokeWidth?: number;
  className?: string;
  style?: CSSProperties;
  title?: string;
  'aria-label'?: string;
  onClick?: () => void;
}

export function Icon({
  name,
  size = 16,
  color,
  strokeWidth = 2,
  className,
  style,
  title,
  onClick,
  'aria-label': ariaLabel,
}: IconProps) {
  const Cmp = REGISTRY[name];
  return (
    <Cmp
      size={size}
      color={color}
      strokeWidth={strokeWidth}
      className={className}
      onClick={onClick}
      aria-label={ariaLabel}
      aria-hidden={ariaLabel || title ? undefined : true}
      style={{ display: 'inline-block', verticalAlign: '-0.15em', flexShrink: 0, ...style }}
    >
      {title ? <title>{title}</title> : null}
    </Cmp>
  );
}

export default Icon;
